import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";
import {MatPaginator} from "@angular/material/paginator";
import {RegistrationIdentifier} from "../../../shared/interface/registration-identifier";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {IdentifierService} from "../../../shared/services/identifier.service";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../../shared/services/auth.service";
import {ActivatedRoute, Router} from "@angular/router";
import {FilterService} from "../../../shared/services/filter.service";
import {Store} from "@ngrx/store";
import {StoreRootState} from "../../../shared/ngrx/reducers";
import {takeUntil, tap} from "rxjs/operators";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {Uuid} from "../../../shared/interface/response/uuid";
import {JobResultDialogComponent} from "../../../shared/components/job-result-dialog/job-result-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {AnalyticsService} from "../../../shared/services/analytics.service";
import {InsuranceCompany} from "../../../shared/interface/insurance-company";

@Component({
  selector: 'app-report-identifiers',
  templateUrl: './report-identifiers.component.html',
  styleUrls: ['./report-identifiers.component.scss']
})
export class ReportIdentifiersComponent implements OnInit, OnDestroy {
  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;



  initialFilters: any;
  typeOnlyKeys: any = undefined;
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  constructor(
    private analyticsService: AnalyticsService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
    private activatedRoute: ActivatedRoute,
    private filterService: FilterService,
    private store: Store<StoreRootState>,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.parseFilters();
  }

  ngOnInit(): void {
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      ofwca: 'string',
      insuranceCompany: 'int[]',
      status: 'int',
      type: 'int',
      contains$value: 'string',
      partner: 'string',
      assetsRegional: 'string[]',
      valueIdentifiers: 'int',
    }, filters);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }


  filter(): void {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: 0,
        pageSize: 10,
        ...this.filtersForm.value,
      })]);
  }

  downloadReport(): void {
    this.analyticsService.downloadReportIdentifiers(this.initialFilters)
      .subscribe((response: Uuid) => {
        const dialogRef = this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
        page: 0,
        pageSize: 10,
      }]);
  }
  insuranceCompanyFilterChanged(insuranceCompanies: InsuranceCompany[]): void {
    const registrationIdTypes = [];

    insuranceCompanies.forEach((insuranceCompany: InsuranceCompany) => {
      registrationIdTypes.push(...insuranceCompany.registrationIdTypes);
    });

    if (registrationIdTypes.length > 0) {
      this.typeOnlyKeys = registrationIdTypes;
    } else {
      this.typeOnlyKeys = undefined;
    }
  }
}
